import { ArchiveIcon as PhosphorArchiveIcon } from "@phosphor-icons/react/dist/ssr/Archive";

import { createAppIcon } from "@/components/createAppIcon";

export const InventoryIcon = /* @__PURE__ */ createAppIcon(PhosphorArchiveIcon);
